import React from 'react';
import type { BuilderSection } from 'types/websiteBuilder';
import SectionRenderer from '../sections/SectionRenderer';
import styles from './Canvas.module.scss';

interface SectionWrapperProps {
  section: BuilderSection;
  previewMode: boolean;
  stickyTop?: boolean;
  avoidStickyOverlay?: boolean;
  avoidHeaderBodyGap?: boolean;
  avoidPreviousOverlap?: boolean;
  avoidSliderCampaignHeroGap?: boolean;
  onSelect: () => void;
  onUpdateData: (data: Record<string, unknown>) => void;
}

function SectionWrapper({
  section,
  previewMode,
  stickyTop = false,
  avoidStickyOverlay = false,
  avoidHeaderBodyGap = false,
  avoidPreviousOverlap = false,
  avoidSliderCampaignHeroGap = false,
  onSelect,
  onUpdateData,
}: SectionWrapperProps) {
  const heightValue =
    typeof section.data.height === 'number' ? section.data.height : undefined;
  const rawContentMaxWidth = section.data.contentMaxWidth;
  const maxWidthValue =
    typeof rawContentMaxWidth === 'number' ? rawContentMaxWidth : undefined;
  const isDonateBodySection =
    section.type === 'body' && section.data.variant === 'donate';
  const shouldApplyMaxWidth = section.type !== 'hero' && !isDonateBodySection;

  const contentStyle: React.CSSProperties = {
    ...(heightValue ? { minHeight: `${heightValue}px` } : {}),
    ...(shouldApplyMaxWidth && maxWidthValue
      ? { maxWidth: `${maxWidthValue}px`, margin: '0 auto' }
      : {}),
  };

  return (
    <div
      className={`${styles.sectionWrapper} ${!previewMode ? styles.sectionWrapperClickable : ''} ${stickyTop ? styles.sectionWrapperSticky : ''} ${avoidStickyOverlay ? styles.sectionWrapperAvoidStickyOverlay : ''} ${avoidHeaderBodyGap ? styles.sectionWrapperAvoidHeaderBodyGap : ''} ${avoidPreviousOverlap ? styles.sectionWrapperAvoidPreviousOverlap : ''} ${avoidSliderCampaignHeroGap ? styles.sectionWrapperAvoidSliderCampaignHeroGap : ''}`}
      onClick={() => {
        if (!previewMode) onSelect();
      }}
      role={previewMode ? undefined : 'button'}
      tabIndex={previewMode ? undefined : 0}
      onKeyDown={(e) => {
        if (previewMode) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onSelect();
        }
      }}
      aria-label={`Section: ${section.type}`}
    >
      <div className={styles.sectionContent} style={contentStyle}>
        <SectionRenderer section={section} onUpdateData={onUpdateData} />
      </div>
    </div>
  );
}

export default SectionWrapper;
